const UKRAINE_COUNTRY_CODE = 'UA';
const ROMANIA_COUNTRY_CODE = 'RO';
const UKRAINE_TIMEZONES = new Set(['Europe/Kyiv', 'Europe/Kiev']);
const ROMANIA_TIMEZONES = new Set(['Europe/Bucharest']);

/**
 * Extract ISO 3166-1 alpha-2 region from browser locale(s) or timezone.
 */
export const getUserRegion = () => {
  if (typeof navigator === 'undefined') {
    return null;
  }

  try {
    const locales = navigator.languages?.length
      ? navigator.languages
      : [navigator.language];

    for (const locale of locales) {
      if (!locale) continue;

      const parsed = new Intl.Locale(locale);
      if (parsed.region) {
        return parsed.region.toUpperCase();
      }

      const parts = locale.split('-');
      if (parts.length >= 2) {
        const region = parts[parts.length - 1];
        if (region.length === 2) {
          return region.toUpperCase();
        }
      }
    }

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (UKRAINE_TIMEZONES.has(timeZone)) {
      return UKRAINE_COUNTRY_CODE;
    }
    if (ROMANIA_TIMEZONES.has(timeZone)) {
      return ROMANIA_COUNTRY_CODE;
    }
  } catch {
    // Ignore locale parsing errors and fall back to default language.
  }

  return null;
};

export const getLanguageFromRegion = (region = getUserRegion()) => {
  if (region === UKRAINE_COUNTRY_CODE) {
    return 'uk';
  }
  if (region === ROMANIA_COUNTRY_CODE) {
    return 'ro';
  }

  return 'en';
};
